import type { MeasuredAudioProperties } from '@/api/types'

/** Describe decoded properties without treating a codec as proof of mastering. */
export function qualityDescription(measured?: MeasuredAudioProperties): string {
  if (!measured?.codec) return 'Not measured yet'
  const parts = [measured.codec.toUpperCase()]
  if (measured.lossless_codec === true) parts.push('lossless codec')
  else if (measured.lossless_codec === false) parts.push('lossy codec')
  if (measured.sample_rate) parts.push(`${measured.sample_rate / 1000} kHz`)
  if (measured.bit_depth) parts.push(`${measured.bit_depth}-bit`)
  if (measured.channels) parts.push(`${measured.channels} channels`)
  if (measured.bitrate_kbps) parts.push(`${measured.bitrate_kbps} kbps`)
  return parts.join(' · ')
}
